export default "__VITE_ASSET__BXj3lCED__"